import { BaseService } from '../../../infra/base.service'
import type { ProductMovement } from './product-movement'
import type { ProductMovementsRepository } from './product-movements.repository'

export class ProductMovementsService extends BaseService<ProductMovement> {
    constructor(private rep: ProductMovementsRepository) {
        super(rep)
    }
}
